import api from '../api';

import CrmSyncActions from 'actions/crm/CrmSyncActions';

/** CallSyncCrmSource implements interactions with the sync-data endpoint */
const CallSyncCrmSource = {
  syncData: {
    remote(state, fileUploadId, contact = null, company = null, objectId = null) {
      const config = {baseURL: '/apiv2/crm'};
      let data = {};
      if (contact) {
        data.contact = contact;
      }
      if (company) {
        data.company = company;
      }
      if (objectId) {
        data.object_id = objectId;
      }
      return api.post(`/sync_data/${fileUploadId}`, data, config);
    },
    loading: CrmSyncActions.syncCrmDataLoading,
    success: CrmSyncActions.syncCrmDataSuccess,
    error: CrmSyncActions.syncCrmDataError,
  },
};

export default CallSyncCrmSource;
